(function() {
    'use strict';

    var serviceId = 'datacontext';
    angular.module('app').factory(serviceId, ['common','config', '$http', datacontext]);

    function datacontext(common, config, $http) {
        var $q = common.$q;
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(serviceId);

        var service = {
            // utilities
            queryToXLS: queryToXLS,

            // Pickpack
            get_pickpack_slips: get_pickpack_slips,
            updatePickPackSlip:updatePickPackSlip,
            updatepremiumCnt:updatepremiumCnt,
            is_just_picked:is_just_picked,
            is_item_missing:is_item_missing,
            update_cubby:update_cubby,
            update_auto_cubby:update_auto_cubby,
            update_list_notes:update_list_notes,
            get_print_cnt:get_print_cnt,
            get_pickpack_pending_count: get_pickpack_pending_count,
            get_pickpack_pending_count_v1:get_pickpack_pending_count_v1,
            get_pending_prime_count:get_pending_prime_count,
            get_pending_prime_cat_count:get_pending_prime_cat_count,
            get_pending_cat_count:get_pending_cat_count,
            get_pending_cat_count_tom:get_pending_cat_count_tom,
            get_pending_cat_count_pl:get_pending_cat_count_pl,
            get_pending_cat_count_all:get_pending_cat_count_all,
            get_today_count:get_today_count,
            get_walmart_ebay:get_walmart_ebay,
            createPickpackSlip: createPickpackSlip,
            populatePickpackSlip: populatePickpackSlip,
            autoPopulatePickpackSlip: autoPopulatePickpackSlip,
            stopAutoPopulatePickpackSlip: stopAutoPopulatePickpackSlip,
            populatePickpackSlipDueToday:populatePickpackSlipDueToday,
            delete_pickpack_slip: delete_pickpack_slip,
            fix_unpacked_orders: fix_unpacked_orders,
            get_pick_list: get_pick_list,
            update_pick_list: update_pick_list,
            update_pick_list_wfp: update_pick_list_wfp,
            update_pick_list_summary:update_pick_list_summary,
            get_order_picklists:get_order_picklists,
            check_wfp_image:check_wfp_image,
            update_printer:update_printer,
            create_xerox_csv_ftp:create_xerox_csv_ftp,
            create_ricoh_xerox_csv_ftp:create_ricoh_xerox_csv_ftp,
            create_cal_km_xerox_csv_ftp:create_cal_km_xerox_csv_ftp,
            print_all:print_all,
            done_print_all:done_print_all,
            print_all_can:print_all_can,
            print_all_hp:print_all_hp,
            print_all_EPSON777_1:print_all_EPSON777_1,
            print_all_EPSON777_2:print_all_EPSON777_2,
            print_all_EPSON777_3:print_all_EPSON777_3,
            print_all_EPSON777_4:print_all_EPSON777_4,
            reprint_cover:reprint_cover,
            get_package_items:get_package_items,
            getPackList: getPackList,
            update_pack_list: update_pack_list,
            getEligibleShips: getEligibleShips,
            getPackageDimensions: getPackageDimensions,
            update_shipped_on: update_shipped_on,
            repack_order:repack_order,
            damaged_reprint:damaged_reprint,
            get_pickpack_status:get_pickpack_status,
            get_pickpack_types:get_pickpack_types,
            get_pickpack_types_v1:get_pickpack_types_v1,
            get_pickpack_types_sort_v1:get_pickpack_types_sort_v1,
            get_pickpack_typesv2:get_pickpack_typesv2,
            get_pickpack_types_defaultship:get_pickpack_types_defaultship,
            get_skip_items_at_pack:get_skip_items_at_pack,
            get_missings_items_at_pick:get_missings_items_at_pick,
            getPickPackItems:getPickPackItems,
            getPrintAllStatus:getPrintAllStatus,
            getPickPackItems_summary:getPickPackItems_summary,
            createBarCode:createBarCode,
            get_empty_locations_cnt:get_empty_locations_cnt,
            get_last_import_cnt:get_last_import_cnt,
            get_shipby_lastfive:get_shipby_lastfive,
            remove_fba_locations: remove_fba_locations,
            getOrderPrintFull:getOrderPrintFull,
            getOrderPrintFullFnsku:getOrderPrintFullFnsku,
            get_waybill_num: get_waybill_num,
            ins_waybill_num: ins_waybill_num,
            get_premium_orders:get_premium_orders,
            close_list_update:close_list_update,
            update_pickpack_status:update_pickpack_status,
            update_list_picked:update_list_picked,
            createShipment:createShipment,
            // Orders
            get_orders:get_orders,
            get_orders_list:get_orders_list,
            suggestion_box:suggestion_box,
            create_order:create_order,
            getOrderItems:getOrderItems,
            get_order_status:get_order_status,
            get_order_sub_status:get_order_sub_status,
            get_order_sub_status_v1:get_order_sub_status_v1,
            get_financial_status:get_financial_status,
            get_cancel_reasons:get_cancel_reasons,
            get_fulfillment_status:get_fulfillment_status,
            get_order_packages_status:get_order_packages_status,
            create_order_item:create_order_item,
            updateOrderItem:updateOrderItem,
            update_order_shipped: update_order_shipped,
            submit_pack_audit:submit_pack_audit,
            update_order_financial_status:update_order_financial_status,
            update_order_fulfillment_status:update_order_fulfillment_status,
            createShipLabel: createShipLabel,
            createShipLabelSFP:createShipLabelSFP,
            createShipLabelSFPMulti:createShipLabelSFPMulti,
            createShipLabelSFPMultiAtPack:createShipLabelSFPMultiAtPack,
            createShiplabel1: createShiplabel1,
            getShiplabel: getShiplabel,
            get_open_items: get_open_items,
            updateOrder: updateOrder,
            update_order_note:update_order_note,
            cancelOrder:cancelOrder,
            cancelCompleteOrder:cancelCompleteOrder,
            update_shipping_service:update_shipping_service,
            getOrderByStore: getOrderByStore,
            importAmazonMissedOrder:importAmazonMissedOrder,
            importAmazonMissedOnsiteOrder:importAmazonMissedOnsiteOrder,
            importWalmartMissedOrder:importWalmartMissedOrder,
            createMissedOrder:createMissedOrder,
            createmanualorder:createmanualorder,
            parseAmazonMissedOrder:parseAmazonMissedOrder,
            // endicia
            endicia_order_export:endicia_order_export,
            endicia_order_import:endicia_order_import,
            //Customs data
            export_customs_data:export_customs_data,

            // bol
            getBillOfLading: getBillOfLading,
            createBillOfLading: createBillOfLading,

            // abol
            requestShipLabel:requestShipLabel,

            // order packages
            createOrderPackage:createOrderPackage,
            createPackage:createPackage,
            updateOrderPackage:updateOrderPackage,
            updatePackageABS:updatePackageABS,
            updateFullPackageABS:updateFullPackageABS,
            updatePackageEndicia:updatePackageEndicia,
            getOrderPackageFull:getOrderPackageFull,
            getOrderProductSet:getOrderProductSet,
            get_order_packages: get_order_packages,
            get_pending_wfp:get_pending_wfp,
            update_package_pack_type_id: update_package_pack_type_id,
            alertpackupdate: alertpackupdate,

            get_order_package_status:get_order_package_status,
            get_order_package_types:get_order_package_types,

            get_order_package_aging:get_order_package_aging,
            get_order_package_aging_v1:get_order_package_aging_v1,
            manual_orders_no_tracking:manual_orders_no_tracking,
            get_order_package_ship_method:get_order_package_ship_method,
            get_order_shipments:get_order_shipments,

            reset_order_package:reset_order_package,
            cancel_open_order_packages:cancel_open_order_packages,
            resetPickPackItem:resetPickPackItem,

            get_order_package_items:get_order_package_items,
            get_order_package_items_cnt:get_order_package_items_cnt,
            createOrderPackageItem:createOrderPackageItem,
            updateOrderPackageItem:updateOrderPackageItem,

            //SplitOrder
            splitOrderPackage:splitOrderPackage,

            //manual cubbies
            get_held_manual_cubbies: get_held_manual_cubbies,
            update_held_manual_cubby: update_held_manual_cubby,

            // Users
            user_login:user_login,
            get_users: get_users,
            get_customers: get_customers,
            edit_customer:edit_customer,
            get_users_mes:get_users_mes,
            send_message:send_message,
            read_message:read_message,
            get_user_role: get_user_role,
            update_user: update_user,
            ins_user:ins_user,
            get_user_detail: get_user_detail,

            // Products
            get_products: get_products,
            get_products_list: get_products_list,
            get_product_detail: get_product_detail,
            get_product_status:get_product_status,
            get_product_source:get_product_source,
            update_ps_pid_cnt:update_ps_pid_cnt,
            update_active_ps_pid_cnt:update_active_ps_pid_cnt,
            get_amazon_subjects:get_amazon_subjects,
            get_product_pod_dimensions:get_product_pod_dimensions,
            get_content_themes:get_content_themes,
            update_theme_pid_cnt:update_theme_pid_cnt,
            update_active_ct_pid_cnt:update_active_ct_pid_cnt,
            get_amz_overselling:get_amz_overselling,
            get_spid_synd_sync_fail:get_spid_synd_sync_fail,
            get_spid_synd_sync_pending_pa_amz:get_spid_synd_sync_pending_pa_amz,
            get_spid_synd_sync_active_pa_amz:get_spid_synd_sync_active_pa_amz,
            get_spid_synd_sync_pending_pf_amz:get_spid_synd_sync_pending_pf_amz,
            get_spid_synd_sync_active_pf_amz:get_spid_synd_sync_active_pf_amz,
            get_inactive_being_sold:get_inactive_being_sold,
            get_products_title_too_long:get_products_title_too_long,
            get_parent_relationship_pending_count:get_parent_relationship_pending_count,
            get_ebay_overselling:get_ebay_overselling,
            create_product:create_product,
            update_product: update_product,
            tm_review:tm_review,
            get_next_product_not_fit_to_sell:get_next_product_not_fit_to_sell,
            reProcess_framed_images:reProcess_framed_images,
            reProcess_2436_images:reProcess_2436_images,
            print_wfp_regular:print_wfp_regular,
            print_wfp_rotate:print_wfp_rotate,
            print_wfp_regular_can:print_wfp_regular_can,
            print_wfp_rotate_can:print_wfp_rotate_can,
            print_wfp_canvas_regular:print_wfp_canvas_regular,
            print_wfp_canvas_rotate:print_wfp_canvas_rotate,
            print_wfp_hp_regular:print_wfp_hp_regular,
            print_wfp_hp_rotate:print_wfp_hp_rotate,
            print_wfp_epson_777_1_regular:print_wfp_epson_777_1_regular,
            print_wfp_epson_777_1_rotate:print_wfp_epson_777_1_rotate,
            print_wfp_epson_777_2_regular:print_wfp_epson_777_2_regular,
            print_wfp_epson_777_2_rotate:print_wfp_epson_777_2_rotate,
            print_wfp_epson_777_3_regular:print_wfp_epson_777_3_regular,
            print_wfp_epson_777_3_rotate:print_wfp_epson_777_3_rotate,
            print_wfp_epson_777_4_regular:print_wfp_epson_777_4_regular,
            print_wfp_epson_777_4_rotate:print_wfp_epson_777_4_rotate,
            print_wfp_epson_777_5_regular:print_wfp_epson_777_5_regular,
            print_wfp_epson_777_5_rotate:print_wfp_epson_777_5_rotate,
            print_wfp_epson_777_6_regular:print_wfp_epson_777_6_regular,
            print_wfp_epson_777_6_rotate:print_wfp_epson_777_6_rotate,
            swap_dimensions:swap_dimensions,
            print_poster_master_pid:print_poster_master_pid,
            print_poster_pid:print_poster_pid,
            print_poster_xerox_master_pid:print_poster_xerox_master_pid,
            print_poster_xerox_pid:print_poster_xerox_pid,
            dup_upc_check:dup_upc_check,
            createContentTheme:createContentTheme,
            editContentTheme:editContentTheme,
            editLeadTime:editLeadTime,
            updLeadTime:updLeadTime,
            allocate_upc:allocate_upc,
            allocate_gco_upc:allocate_gco_upc,
            reQueueProductImage:reQueueProductImage,
            get_product_audit_needed:get_product_audit_needed,
            delete_location_audit:delete_location_audit,
            add_location_audit:add_location_audit,
            get_clone_kws:get_clone_kws,
            get_clone_akws:get_clone_akws,
            refresh_on_hand:refresh_on_hand,
            refresh_on_hand_mpid:refresh_on_hand_mpid,
            get_product_save_search:get_product_save_search,
            get_product_categories:get_product_categories,
            get_product_orientation:get_product_orientation,
            get_product_lead_time_group:get_product_lead_time_group,
            get_product_lead_time_group_v1:get_product_lead_time_group_v1,
            get_faster_lead_times:get_faster_lead_times,
            get_product_categories_v1:get_product_categories_v1,
            get_product_categories_list:get_product_categories_list,
            get_product_categories_list_v1:get_product_categories_list_v1,
            update_product_attributes:update_product_attributes,
            update_product_attributes_done_all_sizes:update_product_attributes_done_all_sizes,
            update_product_name_all_sizes:update_product_name_all_sizes,
            update_product_root:update_product_root,
            update_product_source:update_product_source,
            search_spids:search_spids,
            delete_set:delete_set,
            update_set:update_set,
            getProductSets:getProductSets,
            add_sets:add_sets,


            // product relationships
            getProductRelationshipTypes:getProductRelationshipTypes,
            getStoreProductRelationships:getStoreProductRelationships,
            getAllRelations:getAllRelations,
            getProductRelationships:getProductRelationships,
            getProductAttributes:getProductAttributes,
            create_product_relationship:create_product_relationship,
            deleteProductRelationship:deleteProductRelationship,

            // product attributes
            get_product_attributes:get_product_attributes,
            create_product_attribute:create_product_attribute,
            delete_product_attribute:delete_product_attribute,

            // product parents
            createProductParent:createProductParent,
            update_product_parent:update_product_parent,
            resend_parent_relationship_childs:resend_parent_relationship_childs,
            update_product_parent_audit:update_product_parent_audit,
            update_product_parent_color_prefix:update_product_parent_color_prefix,
            parent_override:parent_override,
            add_spid_product_parent:add_spid_product_parent,
            deleteProductParent:deleteProductParent,
            get_product_parent:get_product_parent,
            get_missing_title_parents:get_missing_title_parents,
            get_color_variation_issue_parents:get_color_variation_issue_parents,
            get_child_cnt_zero_parents:get_child_cnt_zero_parents,
            get_product_parent_v1:get_product_parent_v1,
            get_store_products_for_parent:get_store_products_for_parent,
            get_product_parent_status:get_product_parent_status,
            get_duplicate_asin_product_parents:get_duplicate_asin_product_parents,
            update_product_rollup_count:update_product_rollup_count,
            check_temp_search_products:check_temp_search_products,
            ins_save_search_products:ins_save_search_products,
            update_save_search_products:update_save_search_products,

            // product locations
            get_backstockRestock:get_backstockRestock,
            get_product_location:get_product_location,
            get_common_locations:get_common_locations,
            delete_location_product:delete_location_product,

            // Stores
            get_stores: get_stores,
            get_stores_v1: get_stores_v1,
            get_store_dashboard:get_store_dashboard,
            get_available_stores_via_product:get_available_stores_via_product,

            // Store Products
            get_store_products: get_store_products,
            get_gcid_store_products: get_gcid_store_products,
            get_inv_to_push_store_products:get_inv_to_push_store_products,
            get_store_products_from_parent:get_store_products_from_parent,
            get_reprice_cnt: get_reprice_cnt,
            get_store_products_sp_list:get_store_products_sp_list,
            get_store_products_p_list:get_store_products_p_list,
            create_store_product:create_store_product,
            update_store_product:update_store_product,
            remove_store_product:remove_store_product,
            get_store_product_status:get_store_product_status,
            get_next_product_no_sku:get_next_product_no_sku,
            get_price_rules:get_price_rules,
            get_shipping_regions:get_shipping_regions,
            get_faire_variants:get_faire_variants,
            get_store_product_scrape_status:get_store_product_scrape_status,
            get_reprice_reason:get_reprice_reason,
            get_reprice_history:get_reprice_history,
            get_wal_reprice:get_wal_reprice,
            get_min_max_rules:get_min_max_rules,
            get_amz_buybox_status:get_amz_buybox_status,
            calc_mp_avail_no_qtytosell_check:calc_mp_avail_no_qtytosell_check,
	           check_temp_search:check_temp_search,
            ins_save_search:ins_save_search,
            update_save_search:update_save_search,
            get_save_search:get_save_search,
            //todo merge with get_store_products
            get_store_product_detail:get_store_product_detail,

            // Vendors
            create_vendor:create_vendor,
            update_vendor:update_vendor,
            audit_vendor:audit_vendor,
            get_vendors:get_vendors,
            get_vendors_v1:get_vendors_v1,
            get_vendors_list:get_vendors_list,
            get_manufacturer_report:get_manufacturer_report,
            get_vendor_detail:get_vendor_detail,
            get_vendor_product_lines:get_vendor_product_lines,
            remove_parent:remove_parent,
            get_vendor_auth_stores:get_vendor_auth_stores,
            delete_vendor_auth_stores:delete_vendor_auth_stores,
            create_vendor_auth_stores:create_vendor_auth_stores,
            get_audit_vendor:get_audit_vendor,
            get_vendor_id:get_vendor_id,

            // Vendor Products
            create_vendor_product:create_vendor_product,
            update_vendor_product :update_vendor_product,
            get_vendor_product_list:get_vendor_product_list,
            get_vendor_product_list_count:get_vendor_product_list_count,
            get_vendor_product:get_vendor_product,
            get_vendor_product_reorder:get_vendor_product_reorder,

            get_vendor_stock_status:get_vendor_stock_status,
            get_vendor_product_po_history:get_vendor_product_po_history,
            get_vendor_product_change_log:get_vendor_product_change_log,
            unique_sku_check:unique_sku_check,
            get_vendor_products_by_vendor:get_vendor_products_by_vendor,

            // Locations
            create_location_product:create_location_product,
            get_location_name:get_location_name,
            update_location_product:update_location_product,
            audit_location_product:audit_location_product,
            get_location_products:get_location_products,
            get_location_types:get_location_types,
            get_open_location:get_open_location,
            get_open_location_v1:get_open_location_v1,
            get_location_history:get_location_history,
            get_location_id:get_location_id,
            get_location_audit:get_location_audit,
            get_on_hand:get_on_hand,
            delete_location:delete_location,
            delete_location_temp:delete_location_temp,
            get_empty_locations:get_empty_locations,
            get_empty_locations_details:get_empty_locations_details,
            get_best_seller:get_best_seller,
            get_audit_history:get_audit_history,
            get_backlights:get_backlights,
            // purchase orders
            create_purchase_order:create_purchase_order,
            update_purchase_order:update_purchase_order,
            get_purchase_orders:get_purchase_orders,
            get_export_po_list:get_export_po_list,
            update_po_totals:update_po_totals,
            get_po_status:get_po_status,
            get_po_types:get_po_types,

            // purchase order items
            get_po_items:get_po_items,
            get_po_items_audit:get_po_items_audit,
            get_po_item_search:get_po_item_search,
            create_po_item:create_po_item,
            update_po_item:update_po_item,
            get_transfer_po_items:get_transfer_po_items,
            get_receiving:get_receiving,
            get_all_pods:get_all_pods,
            get_pod_orders:get_pod_orders,
            populate_picklist_pid:populate_picklist_pid,
            get_message:get_message,
            get_message_cnt:get_message_cnt,

            // Manufacturers
            get_manufacturers:get_manufacturers,
            get_manufacturers_by_name:get_manufacturers_by_name,
            get_manufacturers_no_cache:get_manufacturers_no_cache,
            get_product_source_list:get_product_source_list,
            get_product_source_list_v1:get_product_source_list_v1,
            get_license_region_list:get_license_region_list,
            get_content_themes_list:get_content_themes_list,
            create_manufacturer:create_manufacturer,
            createProductSource:createProductSource,
            editProductSource:editProductSource,

            // customers
            getCustomerAddress:getCustomerAddress,
            get_country_province_list:get_country_province_list,
            get_country_list:get_country_list,
            get_province_list: get_province_list,
            update_customer_address:update_customer_address,
            getInvalidAddressReport:getInvalidAddressReport,

            // amazon
            get_scheduled_tasks:get_scheduled_tasks,
            get_amazon_errors:get_amazon_errors,
            s3readFile:s3readFile,
            mwsFullLookup:mwsFullLookup,

            // marketplace audit
            get_marketplace_upload_log:get_marketplace_upload_log,
            create_marketplace_upload_log:create_marketplace_upload_log,
            get_night_reprice:get_night_reprice,

            // ship methods
            get_ship_methods:get_ship_methods,
            get_ship_methods_v1:get_ship_methods_v1,
            get_pp_shipping_methods:get_pp_shipping_methods,
            update_pp_shipping_method:update_pp_shipping_method,
            get_picklists:get_picklists,
            get_picklist_type_id:get_picklist_type_id,
            get_picklist_slip_id:get_picklist_slip_id,
            get_reship_reasons:get_reship_reasons,
            // below uses lambda
            generateDHLShipLabel:generateDHLShipLabel,

            // audit
            getAuditLog:getAuditLog,
            getAuditSubTypes:getAuditSubTypes,
            create_audit_log:create_audit_log,

            //warehouse
            get_warehouses:get_warehouses,

            // Reporting
            get_sales_velocity:get_sales_velocity,
            qPhantomReview:qPhantomReview,
            get_sales_report:get_sales_report,
            get_walmart_reprice_report:get_walmart_reprice_report,
            get_amazon_reprice_report:get_amazon_reprice_report,
            get_orders_no_tracking:get_orders_no_tracking,
            get_product_sale_history:get_product_sale_history,
            update_sales:update_sales,
            get_orders_manual_shipmethod:get_orders_manual_shipmethod,
            get_asin_import_errors:get_asin_import_errors,
            get_order_report:get_order_report,
            get_order_fulfillment:get_order_fulfillment,
            getPackageStatusCount:getPackageStatusCount,
            get_order_packages_pod:get_order_packages_pod,
            stopTasks:stopTasks,

            // alerts
            getAlertLog:getAlertLog,
            create_alert_link:create_alert_link,
            update_alert_link:update_alert_link,
            getAlertTypes:getAlertTypes,
            getAlertSubTypes:getAlertSubTypes,
            getAlertStatus:getAlertStatus,

            // competitor_products
            competitor_product_list:competitor_product_list,
            phantom_products:phantom_products,
            update_phantom_products:update_phantom_products,
            get_competitor_summary:get_competitor_summary,

            // amazon
            get_aws_variation_themes:get_aws_variation_themes,

            // aws rest api
            marketplace_scrape_check:marketplace_scrape_check,

            // aws rest api
            web_image_scraper:web_image_scraper,

            //asin/order/pid search
            get_asin_list:get_asin_list,
            get_spid_title:get_spid_title,
            get_yoda_order_list:get_yoda_order_list,
            get_yoda_order_list_ebay:get_yoda_order_list_ebay,
            get_picklist_id:get_picklist_id,
            onsite_by_spid:onsite_by_spid,
            get_pid_list:get_pid_list,
            get_spid_list:get_spid_list,
            get_mpid_list:get_mpid_list,
            get_mparent_id_list:get_mparent_id_list,
            get_vsku_list:get_vsku_list,
            get_fnsku_list:get_fnsku_list,
            get_upc_list:get_upc_list,
            update_ship_method:update_ship_method,
            print_image_missing_send_email:print_image_missing_send_email,
            update_note:update_note,

            // Jet
            push_jet_tracking_details:push_jet_tracking_details,

            //Walmart Push Product
            walmart_push_product:walmart_push_product,
            image_format_update:image_format_update,

            //getty
            get_getty_images:get_getty_images,
            get_getty_image_products:get_getty_image_products,
            download_getty_image:download_getty_image,
            download_only_getty_image:download_only_getty_image,
            get_getty_id_list:get_getty_id_list,
            get_getty_list:get_getty_list,
            //stock
            get_stock_images:get_stock_images,
            get_stock_images_dwd:get_stock_images_dwd,
            get_stock_images_dwd_sold:get_stock_images_dwd_sold,
            download_stock_image:download_stock_image,
            download_stock_image_hires:download_stock_image_hires,

            //wayfair
            get_wayfair_subjects_list:get_wayfair_subjects_list,
            get_amazon_subjects_list:get_amazon_subjects_list,

            adjustOrderItems:adjustOrderItems
          };
          return service;

        function marketplace_scrape_check(jsonData,url) {

            return $http({
                method: 'POST',
                url: url,
                data: jsonData, // jquery pass in data as strings
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "X-Amz-Date":"",
                    "Authorization":"",
                    "x-api-key":""
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
                console.log(data);
                console.log(status);
                console.log(headers);
                console.log(config);
            });
        }

        function web_image_scraper(jsonData) {

            /*******
             jsonData : {
                 "image_url":"http://ecx.images-amazon.com/images/I/81r4gO4WqoL._UX679_.jpg",
                 "dstBucket":"image-pending-resize",
                 "dstPath":"",
                 "dstFilename":"1234.jpg",
                 "contentType":"image/jpeg"
             }
             *******/

            return $http({
                method: 'POST',
                url: 'https://cvx8sfyh08.execute-api.us-east-1.amazonaws.com/beta/image-scrape',
                data: jsonData, // jquery pass in data as strings
                headers: {
                    "Content-Type": "application/json",
                    "X-Amz-Date":"",
                    "Authorization":"",
                    "x-api-key":""
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
                console.log(data);
                console.log(status);
                console.log(headers);
                console.log(config);
            });
        }

        function reProcess_framed_images(master_product_id,mat,frame_color) {
            console.log("master_product_id",master_product_id);
            if(frame_color > 0){
              return $http.get('https://ace.gothamcityonline.com/tasks/frame_images/1218_new_white.cfm?pid='+master_product_id+'&matted='+mat)
                  .error(function(data, status, headers, config) {
                      console.log(data);
                      // alert('error ! : ' + status);
                  });
            }else if(mat === 0){
              return $http.get('https://ace.gothamcityonline.com/tasks/frame_images/1218_new.cfm?pid='+master_product_id+'&matted='+mat)
                  .error(function(data, status, headers, config) {
                      console.log(data);
                      // alert('error ! : ' + status);
                  });
            }else{
              return $http.get('https://ace.gothamcityonline.com/tasks/frame_images/1218_grey.cfm?pid='+master_product_id+'&matted='+mat)
                  .error(function(data, status, headers, config) {
                      console.log(data);
                      // alert('error ! : ' + status);
                  });
            }

        }

        function reProcess_2436_images(master_product_id) {
            console.log("master_product_id",master_product_id);
            return $http.get('https://ace.gothamcityonline.com/tasks/frame_images/2436_clone_img.cfm?pid='+master_product_id)
                .error(function(data, status, headers, config) {
                    console.log(data);
                    // alert('error ! : ' + status);
                });
        }

	   function print_wfp_regular(product_id,printer,user_orientation_id,width,height,PID,category_id,pod_dimension_id,hi_res_image_id) {
            return $http.get('https://ace.gothamcityonline.com/tasks/wfp_ftp.cfm?type=REGULAR&MPID='+product_id+'&category_id='+category_id+'&pod_dimension_id='+pod_dimension_id+'&printer='+printer+'&user_orientation_id='+user_orientation_id+'&width='+width+'&height='+height+'&PID='+PID+'&hi_res_image_id='+hi_res_image_id)
                .error(function(data, status, headers, config) {
                    console.log(data);
                    // alert('error ! : ' + status);
                });
        }

        function print_wfp_rotate(product_id,printer,user_orientation_id,width,height,PID,category_id,pod_dimension_id,hi_res_image_id) {

            return $http.get('https://ace.gothamcityonline.com/tasks/wfp_ftp.cfm?type=ROTATE&MPID='+product_id+'&category_id='+category_id+'&pod_dimension_id='+pod_dimension_id+'&printer='+printer+'&user_orientation_id='+user_orientation_id+'&width='+width+'&height='+height+'&PID='+PID+'&hi_res_image_id='+hi_res_image_id)
                .error(function(data, status, headers, config) {
                    console.log(data);
                    // alert('error ! : ' + status);
                });
        }

        function print_wfp_regular_can(product_id,printer,user_orientation_id,width,height,PID,category_id,hi_res_image_id) {
            return $http.get('https://ace.gothamcityonline.com/tasks/wfp_ftp_can.cfm?type=REGULAR&MPID='+product_id+'&category_id='+category_id+'&printer='+printer+'&user_orientation_id='+user_orientation_id+'&width='+width+'&height='+height+'&PID='+PID+'&hi_res_image_id='+hi_res_image_id)
                .error(function(data, status, headers, config) {
                    console.log(data);
                    // alert('error ! : ' + status);
                });
        }

        function print_wfp_rotate_can(product_id,printer,user_orientation_id,width,height,PID,category_id,hi_res_image_id) {

            return $http.get('https://ace.gothamcityonline.com/tasks/wfp_ftp_can.cfm?type=ROTATE&MPID='+product_id+'&category_id='+category_id+'&printer='+printer+'&user_orientation_id='+user_orientation_id+'&width='+width+'&height='+height+'&PID='+PID+'&hi_res_image_id='+hi_res_image_id)
                .error(function(data, status, headers, config) {
                    console.log(data);
                    // alert('error ! : ' + status);
                });
        }

        function print_wfp_canvas_regular(product_id,printer,user_orientation_id,width,height,PID,hi_res_image_id) {
            return $http.get('https://ace.gothamcityonline.com/tasks/wfp_ftp_canvas.cfm?type=REGULAR&MPID='+product_id+'&printer='+printer+'&user_orientation_id='+user_orientation_id+'&width='+width+'&height='+height+'&PID='+PID+'&hi_res_image_id='+hi_res_image_id)
                .error(function(data, status, headers, config) {
                    console.log(data);
                    // alert('error ! : ' + status);
                });
        }

        function print_wfp_canvas_rotate(product_id,printer,user_orientation_id,width,height,PID,hi_res_image_id) {

            return $http.get('https://ace.gothamcityonline.com/tasks/wfp_ftp_canvas.cfm?type=ROTATE&MPID='+product_id+'&printer='+printer+'&user_orientation_id='+user_orientation_id+'&width='+width+'&height='+height+'&PID='+PID+'&hi_res_image_id='+hi_res_image_id)
                .error(function(data, status, headers, config) {
                    console.log(data);
                    // alert('error ! : ' + status);
                });
        }

        function print_wfp_hp_regular(product_id,printer,user_orientation_id,width,height,PID,category_id,pod_dimension_id,hi_res_image_id) {
            return $http.get('https://ace.gothamcityonline.com/tasks/wfp_ftp_hp.cfm?type=REGULAR&MPID='+product_id+'&category_id='+category_id+'&pod_dimension_id='+pod_dimension_id+'&printer='+printer+'&user_orientation_id='+user_orientation_id+'&width='+width+'&height='+height+'&PID='+PID+'&hi_res_image_id='+hi_res_image_id)
                .error(function(data, status, headers, config) {
                    console.log(data);
                    // alert('error ! : ' + status);
                });
        }

        function print_wfp_hp_rotate(product_id,printer,user_orientation_id,width,height,PID,category_id,pod_dimension_id,hi_res_image_id) {

            return $http.get('https://ace.gothamcityonline.com/tasks/wfp_ftp_hp.cfm?type=ROTATE&MPID='+product_id+'&category_id='+category_id+'&pod_dimension_id='+pod_dimension_id+'&printer='+printer+'&user_orientation_id='+user_orientation_id+'&width='+width+'&height='+height+'&PID='+PID+'&hi_res_image_id='+hi_res_image_id)
                .error(function(data, status, headers, config) {
                    console.log(data);
                    // alert('error ! : ' + status);
                });
        }

        function print_wfp_epson_777_1_regular(product_id,printer,user_orientation_id,width,height,PID,category_id,pod_dimension_id,hi_res_image_id) {
            return $http.get('https://ace.gothamcityonline.com/tasks/wfp_ftp_777_1.cfm?type=REGULAR&MPID='+product_id+'&category_id='+category_id+'&pod_dimension_id='+pod_dimension_id+'&printer='+printer+'&user_orientation_id='+user_orientation_id+'&width='+width+'&height='+height+'&PID='+PID+'&hi_res_image_id='+hi_res_image_id)
                .error(function(data, status, headers, config) {
                    console.log(data);
                    // alert('error ! : ' + status);
                });
        }

        function print_wfp_epson_777_1_rotate(product_id,printer,user_orientation_id,width,height,PID,category_id,pod_dimension_id,hi_res_image_id) {

            return $http.get('https://ace.gothamcityonline.com/tasks/wfp_ftp_777_1.cfm?type=ROTATE&MPID='+product_id+'&category_id='+category_id+'&pod_dimension_id='+pod_dimension_id+'&printer='+printer+'&user_orientation_id='+user_orientation_id+'&width='+width+'&height='+height+'&PID='+PID+'&hi_res_image_id='+hi_res_image_id)
                .error(function(data, status, headers, config) {
                    console.log(data);
                    // alert('error ! : ' + status);
                });
        }

        function print_wfp_epson_777_2_regular(product_id,printer,user_orientation_id,width,height,PID,category_id,pod_dimension_id,hi_res_image_id) {
            return $http.get('https://ace.gothamcityonline.com/tasks/wfp_ftp_777_2.cfm?type=REGULAR&MPID='+product_id+'&category_id='+category_id+'&pod_dimension_id='+pod_dimension_id+'&printer='+printer+'&user_orientation_id='+user_orientation_id+'&width='+width+'&height='+height+'&PID='+PID+'&hi_res_image_id='+hi_res_image_id)
                .error(function(data, status, headers, config) {
                    console.log(data);
                    // alert('error ! : ' + status);
                });
        }

        function print_wfp_epson_777_2_rotate(product_id,printer,user_orientation_id,width,height,PID,category_id,pod_dimension_id,hi_res_image_id) {

            return $http.get('https://ace.gothamcityonline.com/tasks/wfp_ftp_777_2.cfm?type=ROTATE&MPID='+product_id+'&category_id='+category_id+'&pod_dimension_id='+pod_dimension_id+'&printer='+printer+'&user_orientation_id='+user_orientation_id+'&width='+width+'&height='+height+'&PID='+PID+'&hi_res_image_id='+hi_res_image_id)
                .error(function(data, status, headers, config) {
                    console.log(data);
                    // alert('error ! : ' + status);
                });
        }

        function print_wfp_epson_777_3_regular(product_id,printer,user_orientation_id,width,height,PID,category_id,pod_dimension_id,hi_res_image_id) {
            return $http.get('https://ace.gothamcityonline.com/tasks/wfp_ftp_777_3.cfm?type=REGULAR&MPID='+product_id+'&category_id='+category_id+'&pod_dimension_id='+pod_dimension_id+'&printer='+printer+'&user_orientation_id='+user_orientation_id+'&width='+width+'&height='+height+'&PID='+PID+'&hi_res_image_id='+hi_res_image_id)
                .error(function(data, status, headers, config) {
                    console.log(data);
                    // alert('error ! : ' + status);
                });
        }

        function print_wfp_epson_777_3_rotate(product_id,printer,user_orientation_id,width,height,PID,category_id,pod_dimension_id,hi_res_image_id) {

            return $http.get('https://ace.gothamcityonline.com/tasks/wfp_ftp_777_3.cfm?type=ROTATE&MPID='+product_id+'&category_id='+category_id+'&pod_dimension_id='+pod_dimension_id+'&printer='+printer+'&user_orientation_id='+user_orientation_id+'&width='+width+'&height='+height+'&PID='+PID+'&hi_res_image_id='+hi_res_image_id)
                .error(function(data, status, headers, config) {
                    console.log(data);
                    // alert('error ! : ' + status);
                });
        }

        function print_wfp_epson_777_4_regular(product_id,printer,user_orientation_id,width,height,PID,category_id,pod_dimension_id,hi_res_image_id) {
            return $http.get('https://ace.gothamcityonline.com/tasks/wfp_ftp_777_4.cfm?type=REGULAR&MPID='+product_id+'&category_id='+category_id+'&pod_dimension_id='+pod_dimension_id+'&printer='+printer+'&user_orientation_id='+user_orientation_id+'&width='+width+'&height='+height+'&PID='+PID+'&hi_res_image_id='+hi_res_image_id)
                .error(function(data, status, headers, config) {
                    console.log(data);
                    // alert('error ! : ' + status);
                });
        }

        function print_wfp_epson_777_4_rotate(product_id,printer,user_orientation_id,width,height,PID,category_id,pod_dimension_id,hi_res_image_id) {

            return $http.get('https://ace.gothamcityonline.com/tasks/wfp_ftp_777_4.cfm?type=ROTATE&MPID='+product_id+'&category_id='+category_id+'&pod_dimension_id='+pod_dimension_id+'&printer='+printer+'&user_orientation_id='+user_orientation_id+'&width='+width+'&height='+height+'&PID='+PID+'&hi_res_image_id='+hi_res_image_id)
                .error(function(data, status, headers, config) {
                    console.log(data);
                    // alert('error ! : ' + status);
                });
        }

        function print_wfp_epson_777_5_regular(product_id,printer,user_orientation_id,width,height,PID,category_id,pod_dimension_id,hi_res_image_id) {
            return $http.get('https://ace.gothamcityonline.com/tasks/wfp_ftp_777_5.cfm?type=REGULAR&MPID='+product_id+'&category_id='+category_id+'&pod_dimension_id='+pod_dimension_id+'&printer='+printer+'&user_orientation_id='+user_orientation_id+'&width='+width+'&height='+height+'&PID='+PID+'&hi_res_image_id='+hi_res_image_id)
                .error(function(data, status, headers, config) {
                    console.log(data);
                    // alert('error ! : ' + status);
                });
        }

        function print_wfp_epson_777_5_rotate(product_id,printer,user_orientation_id,width,height,PID,category_id,pod_dimension_id,hi_res_image_id) {

            return $http.get('https://ace.gothamcityonline.com/tasks/wfp_ftp_777_5.cfm?type=ROTATE&MPID='+product_id+'&category_id='+category_id+'&pod_dimension_id='+pod_dimension_id+'&printer='+printer+'&user_orientation_id='+user_orientation_id+'&width='+width+'&height='+height+'&PID='+PID+'&hi_res_image_id='+hi_res_image_id)
                .error(function(data, status, headers, config) {
                    console.log(data);
                    // alert('error ! : ' + status);
                });
        }

        function print_wfp_epson_777_6_regular(product_id,printer,user_orientation_id,width,height,PID,category_id,pod_dimension_id,hi_res_image_id) {
            return $http.get('https://ace.gothamcityonline.com/tasks/wfp_ftp_777_6.cfm?type=REGULAR&MPID='+product_id+'&category_id='+category_id+'&pod_dimension_id='+pod_dimension_id+'&printer='+printer+'&user_orientation_id='+user_orientation_id+'&width='+width+'&height='+height+'&PID='+PID+'&hi_res_image_id='+hi_res_image_id)
                .error(function(data, status, headers, config) {
                    console.log(data);
                    // alert('error ! : ' + status);
                });
        }

        function print_wfp_epson_777_6_rotate(product_id,printer,user_orientation_id,width,height,PID,category_id,pod_dimension_id,hi_res_image_id) {

            return $http.get('https://ace.gothamcityonline.com/tasks/wfp_ftp_777_6.cfm?type=ROTATE&MPID='+product_id+'&category_id='+category_id+'&pod_dimension_id='+pod_dimension_id+'&printer='+printer+'&user_orientation_id='+user_orientation_id+'&width='+width+'&height='+height+'&PID='+PID+'&hi_res_image_id='+hi_res_image_id)
                .error(function(data, status, headers, config) {
                    console.log(data);
                    // alert('error ! : ' + status);
                });
        }









        function swap_dimensions(formData) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=swap_dimensions',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function print_poster_master_pid(master_product_id,product_id,printer,width,height,category_id,pod_dimension_id,qty_to_print,layout,layout_name,user_orientation_id) {
            return $http.get('https://ace.gothamcityonline.com/tasks/print_poster_manual_wfp_ftp.cfm?MPID='+master_product_id+'&category_id='+category_id+'&pod_dimension_id='+pod_dimension_id+'&printer='+printer+'&width='+width+'&height='+height+'&PID='+product_id+'&layout='+layout+'&layout_name='+layout_name+'&qty_to_print='+qty_to_print+'&user_orientation_id='+user_orientation_id)
                .error(function(data, status, headers, config) {
                    console.log(data);
                    // alert('error ! : ' + status);
                });
        }

        function print_poster_pid(product_id,printer,width,height,category_id,pod_dimension_id,qty_to_print,layout,layout_name,user_orientation_id) {
            return $http.get('https://ace.gothamcityonline.com/tasks/print_poster_manual_wfp_ftp.cfm?MPID='+product_id+'&category_id='+category_id+'&pod_dimension_id='+pod_dimension_id+'&printer='+printer+'&width='+width+'&height='+height+'&PID='+product_id+'&layout='+layout+'&layout_name='+layout_name+'&qty_to_print='+qty_to_print+'&user_orientation_id='+user_orientation_id)
                .error(function(data, status, headers, config) {
                    console.log(data);
                    // alert('error ! : ' + status);
                });
        }

        //https://ace.gothamcityonline.com/tasks/print_poster_manual_xerox.cfm
        function print_poster_xerox_master_pid(master_product_id,product_id,printer,width,height,category_id,pod_dimension_id,qty_to_print,layout,layout_name,user_orientation_id) {
            return $http.get('https://ace.gothamcityonline.com/tasks/print_poster_manual_wfp_ftp.cfm?MPID='+master_product_id+'&category_id='+category_id+'&pod_dimension_id='+pod_dimension_id+'&printer='+printer+'&width='+width+'&height='+height+'&PID='+product_id+'&layout='+layout+'&layout_name='+layout_name+'&qty_to_print='+qty_to_print+'&user_orientation_id='+user_orientation_id)
                .error(function(data, status, headers, config) {
                    console.log(data);
                    // alert('error ! : ' + status);
                });
        }

        function print_poster_xerox_pid(product_id,printer,width,height,category_id,pod_dimension_id,qty_to_print,layout,layout_name,user_orientation_id) {
            return $http.get('https://ace.gothamcityonline.com/tasks/print_poster_manual_wfp_ftp.cfm?MPID='+product_id+'&category_id='+category_id+'&pod_dimension_id='+pod_dimension_id+'&printer='+printer+'&width='+width+'&height='+height+'&PID='+product_id+'&layout='+layout+'&layout_name='+layout_name+'&qty_to_print='+qty_to_print+'&user_orientation_id='+user_orientation_id)
                .error(function(data, status, headers, config) {
                    console.log(data);
                    // alert('error ! : ' + status);
                });
        }

        function queryToXLS(formData) {
            return $http({
                method: 'POST',
                url: '/apis/base.cfc?method=queryToXLS',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_pickpack_slips(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=get_pickpack_slips',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function updatePickPackSlip(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=updatePickPackSlip',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function updatepremiumCnt(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=updatepremiumCnt',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function is_just_picked(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=is_just_picked',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function is_item_missing(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=is_item_missing',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function update_cubby(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=update_cubby',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function update_auto_cubby(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=update_auto_cubby',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        
        function update_list_notes(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=update_list_notes',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_print_cnt(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=get_print_cnt',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function get_pickpack_pending_count_v1(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=get_pickpack_pending_count',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_pickpack_pending_count() {

            return $http.get('/apis/pickpack.cfc?method=get_pickpack_pending_count')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_pending_prime_count() {

            return $http.get('/apis/pickpack.cfc?method=get_pending_prime_count')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_pending_prime_cat_count() {

            return $http.get('/apis/pickpack.cfc?method=get_pending_prime_cat_count')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }
        function get_pending_cat_count() {

            return $http.get('/apis/pickpack.cfc?method=get_pending_cat_count')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }
        function get_pending_cat_count_tom() {

            return $http.get('/apis/pickpack.cfc?method=get_pending_cat_count_tom')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }
        function get_pending_cat_count_pl() {

            return $http.get('/apis/pickpack.cfc?method=get_pending_cat_count_pl')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_pending_cat_count_all() {

            return $http.get('/apis/pickpack.cfc?method=get_pending_cat_count_all')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }


        function get_today_count() {

            return $http.get('/apis/packages.cfc?method=get_today_count')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }
        function get_walmart_ebay() {

            return $http.get('/apis/packages.cfc?method=get_walmart_ebay')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }


        function createBarCode(formData) {
            return $http({
                method: 'POST',
                url: '/apis/barcode.cfc?method=barcodeToFile',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_empty_locations_cnt() {

            return $http.get('/apis/location_product.cfc?method=get_empty_locations_cnt')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }
        function get_last_import_cnt() {

            return $http.get('/apis/pickpack.cfc?method=get_last_import_cnt')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_shipby_lastfive() {

            return $http.get('/apis/packages.cfc?method=get_shipby_lastfive')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function getOrderPrintFull(formData) {
            return $http({
                method: 'POST',
                url: '/apis/orders.cfc?method=getOrderPrintFull',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function createPackage(formData) {
            return $http({
                method: 'POST',
                url: '/apis/packages.cfc?method=create_packages_from_open_orders',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function getOrderPrintFullFnsku(formData) {
            return $http({
                method: 'POST',
                url: '/apis/orders.cfc?method=getOrderPrintFullFnsku',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_waybill_num(formData) {
            return $http({
                method: 'POST',
                url: '/apis/shipping.cfc?method=get_waybill_num',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function ins_waybill_num(formData) {
            return $http({
                method: 'POST',
                url: '/apis/shipping.cfc?method=ins_waybill_num',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function close_list_update(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=close_list_update',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function update_pickpack_status(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=updatePickPackSlip',
                data: $.param(formData),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                
            });
        }

        function update_list_picked(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=update_list_picked',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function createShipment(formData) {
            return $http({
                method: 'POST',
                url: '/apis/shipping.cfc?method=od_page_create_shipment',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }



        function reQueueProductImage(product_id) {
            return $http.get('/apis/amazon.cfc?method=reQueueProductImage&product_id=' + product_id)
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_product_audit_needed(formData) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=get_product_audit_needed',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function delete_location_audit(formData) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=remove_location_audit',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function add_location_audit(formData) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=add_location_audit',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_clone_kws(formData) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=get_clone_kws',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function get_clone_akws(formData) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=get_clone_akws',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }


        function refresh_on_hand(product_id) {
            return $http.get('/tasks/products/calc_product_on_hand.cfm?PID='+product_id)
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }
        function refresh_on_hand_mpid(product_id,master_inv_pid) {
            return $http.get('/tasks/products/calc_product_on_hand_mpid.cfm?PID='+product_id+'&MPID='+master_inv_pid)
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }


        function mwsFullLookup(formData) {
            return $http({
                method: 'POST',
                url: '/apis/amazon/paa.cfc?method=mwsFullLookup',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function createPickpackSlip(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=createPickpackSlip',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function populatePickpackSlip(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=populatePickpackSlip',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function populatePickpackSlipDueToday(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=populatePickpackSlipDueToday',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function autoPopulatePickpackSlip(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=autoPopulatePickpackSlip',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function stopAutoPopulatePickpackSlip(formData) {
        	console.log(formData);
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=stopAutoPopulatePickpackSlip',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function delete_pickpack_slip(idx) {
            return $http.get('/apis/pickpack.cfc?method=delete_pickpack_slip&pickpack_slip_id=' + idx)
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function fix_unpacked_orders(idx) {
            return $http.get('/apis/pickpack.cfc?method=fix_unpacked_orders&pickpack_slip_id=' + idx)
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function resetPickPackItem(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=resetPickPackItem',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_pick_list(idx) {
            return $http.get('/apis/pickpack.cfc?method=get_pick_list&pickpack_slip_id=' + idx)
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_order_picklists(idx) {
            return $http.get('/apis/pickpack.cfc?method=getOrderPicklists&order_age=' + idx.order_age)
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_pickpack_status() {
            return $http.get('/apis/pickpack.cfc?method=get_pickpack_status')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_pickpack_types(formData) {
            // use lodash to find if empty
            if ( _.isEmpty(formData) ) {
                formData = {};
            }

            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=get_pickpack_types',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_held_manual_cubbies(formData) {
            // use lodash to find if empty
            if ( _.isEmpty(formData) ) {
                formData = {};
            }

            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=get_held_manual_cubbies',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function update_held_manual_cubby(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=update_held_manual_cubby',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_pickpack_types_defaultship(formData) {
            // use lodash to find if empty
            if ( _.isEmpty(formData) ) {
                formData = {};
            }

            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=get_pickpack_types_defaultship',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_skip_items_at_pack(formData) {
            // use lodash to find if empty
            if ( _.isEmpty(formData) ) {
                formData = {};
            }

            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=get_skip_items_at_pack',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_missings_items_at_pick(formData) {
            // use lodash to find if empty
            if ( _.isEmpty(formData) ) {
                formData = {};
            }

            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=get_missings_items_at_pick',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

	       function get_pickpack_typesv2(formData) {
            // use lodash to find if empty
            if ( _.isEmpty(formData) ) {
                formData = {};
            }

            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=get_pickpack_typesv2',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function get_pickpack_types_v1(formData) {
           // use lodash to find if empty
           if ( _.isEmpty(formData) ) {
               formData = {};
           }

           return $http({
               method: 'POST',
               url: '/apis/pickpack.cfc?method=get_pickpack_types_v1',
               data: $.param(formData), // jquery pass in data as strings
               headers: {
                   'Content-Type': 'application/x-www-form-urlencoded'
               }
           }).error(function(data, status, headers, config) {
               // alert('error ! : ' + status);
           });
       }
       function get_pickpack_types_sort_v1(formData) {
          // use lodash to find if empty
          if ( _.isEmpty(formData) ) {
              formData = {};
          }

          return $http({
              method: 'POST',
              url: '/apis/pickpack.cfc?method=get_pickpack_types_sort_v1',
              data: $.param(formData), // jquery pass in data as strings
              headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
              }
          }).error(function(data, status, headers, config) {
              // alert('error ! : ' + status);
          });
      }

        function get_premium_orders() {
            return $http.get('/apis/pickpack.cfc?method=get_premium_orders')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function remove_fba_locations() {
            return $http.get('/apis/location_product.cfc?method=remove_fba_locations')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function getPickPackItems(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=getPickPackItems',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function getPrintAllStatus(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=getPrintAllStatus',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function getPickPackItems_summary(formData){
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=getPickPackItems_summary',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function update_pick_list(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=update_pick_list',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function update_pick_list_summary(formData){
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=update_pick_list_summary',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function update_pick_list_wfp(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=update_pick_list_wfp',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function check_wfp_image(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=check_wfp_image',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function getEligibleShips(formData) {
            return $http({
                method: 'POST',
                //url: '/apis/pickpack.cfc?method=getEligibleShips', /* MWS call stopped */
                url: '/apis/sp_api.cfc?method=getEligibleShips', /* SP-API call*/
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function getPackageDimensions(formData) {
            return $http({
                method: 'POST',
                //url: '/apis/pickpack.cfc?method=getPackageDimensions', /* MWS call stopped */
                url: '/apis/sp_api.cfc?method=getPackageDimensions', /* SP-API call*/
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function update_printer(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=update_printer',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function create_xerox_csv_ftp(formData) {
            return $http({
                  method: 'POST',
                  url: '/apis/xerox.cfc?method=create_xerox_csv_ftp',
                  data: $.param(formData),
                  headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                  }
            }).error(function(data, status, headers, config){

            });
        }

        function create_ricoh_xerox_csv_ftp(formData) {
            return $http({
                  method: 'POST',
                  url: '/apis/xerox.cfc?method=create_ricoh_xerox_csv_ftp',
                  data: $.param(formData),
                  headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                  }
            }).error(function(data, status, headers, config){

            });
        }
        function create_cal_km_xerox_csv_ftp(formData) {
            return $http({
                  method: 'POST',
                  url: '/apis/xerox.cfc?method=create_cal_km_xerox_csv_ftp',
                  data: $.param(formData),
                  headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                  }
            }).error(function(data, status, headers, config){

            });
        }

        function print_all(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=print_all',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function done_print_all(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=done_print_all',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function print_all_can(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=print_all_can',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function print_all_hp(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=print_all_hp',
                data: $.param(formData), //jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config){
                // alert('error ! : ' + status);
            });
        }

        function print_all_EPSON777_1(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=print_all_EPSON777_1',
                data: $.param(formData), //jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config){
                // alert('error ! : ' + status);
            });
        }

        function print_all_EPSON777_2(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=print_all_EPSON777_2',
                data: $.param(formData), //jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config){
                // alert('error ! : ' + status);
            });
        }

        function print_all_EPSON777_3(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=print_all_EPSON777_3',
                data: $.param(formData), //jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config){
                // alert('error ! : ' + status);
            });
        }

        function print_all_EPSON777_4(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=print_all_EPSON777_4',
                data: $.param(formData), //jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config){
                // alert('error ! : ' + status);
            });
        }

        function reprint_cover(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=reprint_cover',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

      function get_package_items(formData) {
          return $http({
              method: 'POST',
              url: '/apis/pickpack.cfc?method=get_package_items',
              data: $.param(formData), // jquery pass in data as strings
              headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
              }
          }).error(function(data, status, headers, config) {
              // alert('error ! : ' + status);
          });
      }
        function getPackList(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=getPackList',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function update_pack_list(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=update_pack_list',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function update_shipped_on(order_package_id) {
        	return $http.get('/apis/packages.cfc?method=update_shipped_on&order_package_id=' + order_package_id)
            .error(function(data, status, headers, config) {
                 // alert('error ! : ' + status);
            });

        }

        function repack_order(formData) {

            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=resetPickPackItem',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function damaged_reprint(order_id,order_package_id,package_item_id,product_id,store_product_id,order_item_id) {
        	return $http.get('/apis/packages.cfc?method=damaged_reprint&order_package_id=' + order_package_id+'&order_id='+order_id+'&package_item_id='+package_item_id+'&product_id='+product_id+'&store_product_id='+store_product_id+'&order_item_id='+order_item_id)
            .error(function(data, status, headers, config) {
                 // alert('error ! : ' + status);
            });

        }

        function createShipLabel(formData) {
            return $http({
                method: 'POST',
                url: '/apis/shipping.cfc?method=createShipLabel',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function createShipLabelSFP(formData) {
            return $http({
                method: 'POST',
                url: '/apis/shipping.cfc?method=createShipLabelSFP',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function createShipLabelSFPMulti(formData) {
            return $http({
                method: 'POST',
                url: '/apis/shipping.cfc?method=createShipLabelSFPMulti',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function createShipLabelSFPMultiAtPack(formData){
            return $http({
                method: 'POST',
                url: 'apis/shipping.cfc?method=createShipLabelSFPMultiAtPack',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function createShiplabel1(formData) {
            return $http({
                method: 'POST',
                url: '/apis/shipping.cfc?method=createShipLabelDHL',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function getShiplabel(formData) {
            return $http({
                method: 'POST',
                url: '/apis/shipping.cfc?method=getShiplabel',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function generateDHLShipLabel(formData) {
            return $http({
                method: 'POST',
                url: 'https://cvx8sfyh08.execute-api.us-east-1.amazonaws.com/beta/dhl-ship-label',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'content-type': 'application/x-www-form-urlencoded',
                    'x-api-key':'UEfIPWAVL43nw37xrZS6f8equj5qR7p6nomDwzUd'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_orphan_store_products(formData) {
            return $http({
                method: 'POST',
                url: '/apis/store_products.cfc?method=get_orphan_store_products',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'content-type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function requestShipLabel(formData) {
            return $http({
                method: 'POST',
                url: 'http://api.iabol.com/apiv2/iabolxml.asmx/SendPackageXml',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_order_status() {
            return $http.get('/apis/orders.cfc?method=get_order_status')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_order_sub_status(){
        	return $http.get('/apis/orders.cfc?method=get_order_sub_status')
            .error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function get_order_sub_status_v1(){
        	return $http.get('/apis/orders.cfc?method=get_order_sub_status_v1')
            .error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_financial_status() {
            return $http.get('/apis/orders.cfc?method=get_financial_status')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_fulfillment_status() {
            return $http.get('/apis/orders.cfc?method=get_fulfillment_status')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_order_packages_status() {
            return $http.get('/apis/orders.cfc?method=get_order_packages_status')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_cancel_reasons() {
            return $http.get('/apis/orders.cfc?method=get_cancel_reasons')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_orders(formData) {
            return $http({
                method: 'POST',
                url: '/apis/orders.cfc?method=get_orders',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_orders_list(formData) {
            return $http({
                method: 'POST',
                url: '/apis/orders.cfc?method=get_orders_list',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function suggestion_box(formData) {
            return $http({
                method: 'POST',
                url: '/apis/stores.cfc?method=suggestion_box',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function getOrderItems(formData) {
            return $http({
                method: 'POST',
                url: '/apis/orders.cfc?method=getOrderItems',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_open_items() {
            return $http.get('/apis/orders.cfc?method=get_open_items')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function create_order(formData) {
            return $http({
                method: 'POST',
                url: '/apis/orders.cfc?method=createOrder',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function create_order_item(formData) {
            return $http({
                method: 'POST',
                url: '/apis/orders.cfc?method=createOrderItem',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function updateOrder(formData) {
            return $http({
                method: 'POST',
                url: '/apis/orders.cfc?method=updateOrder',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }


        function update_order_financial_status(formData) {
            return $http({
                method: 'POST',
                url: '/apis/orders.cfc?method=update_order_financial_status',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function update_order_fulfillment_status(formData) {
            return $http({
                method: 'POST',
                url: '/apis/orders.cfc?method=update_order_fulfillment_status',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function cancelOrder(formData) {
            return $http({
                method: 'POST',
                url: '/apis/orders.cfc?method=cancelOrder',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function cancelCompleteOrder(formData) {
            return $http({
                method: 'POST',
                url: '/apis/orders.cfc?method=cancelCompleteOrder',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function update_order_note(formData) {
            return $http({
                method: 'POST',
                url: '/apis/orders.cfc?method=update_order_note',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function update_order_shipped(formData) {
            return $http({
                method: 'POST',
                url: '/apis/orders.cfc?method=update_order_shipped',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function submit_pack_audit(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=submit_pack_audit',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }



        function getOrderByStore() {
            return $http.get('/apis/orders.cfc?method=getOrderByStore')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }


        function user_login(formData) {
            return $http({
                method: 'POST',
                url: '/apis/users.cfc?method=user_login',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_users(formData) {
            return $http({
                method: 'POST',
                url: '/apis/users.cfc?method=get_users',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_customers(formData) {
            return $http({
                method: 'POST',
                url: '/apis/customers.cfc?method=get_customers',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function edit_customer(formData) {
              return $http({
                    method: 'POST',
                    url: '/apis/customers.cfc?method=edit_customer',
                    data: $.param(formData),
                    headers: {
                          'Content-Type': 'application/x-www-form-urlencoded'
                    }
              }).error(function(data, status, headers, config) {
              // alert('error ! : ' + status);
              });
        }

        function send_message(formData) {
            return $http({
                method: 'POST',
                url: '/apis/message.cfc?method=send_message',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function get_users_mes() {
            return $http.get('/apis/users.cfc?method=get_users_mes')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

    function read_message(message_id) {
        return $http.get('/apis/message.cfc?method=read_message&message_id='+message_id)
            .error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
      }
        function get_user_role(formData) {

            // use lodash to find if empty
            if ( _.isEmpty(formData) ) {
                formData = {};
            }

            return $http({
                method: 'POST',
                url: '/apis/users.cfc?method=get_user_role',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function update_user(formData) {
            return $http({
                method: 'POST',
                url: '/apis/users.cfc?method=update_user',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function ins_user(formData) {
            return $http({
                method: 'POST',
                url: '/apis/users.cfc?method=ins_user',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_user_detail(uid) {
            return $http.get('/apis/users.cfc?method=get_user_detail&user_id=' + uid)
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_products(formData) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=get_products',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_products_list(formData) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=get_products_list',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_product_status() {
            return $http.get('/apis/products.cfc?method=get_product_status')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_product_source() {
            return $http.get('/apis/products.cfc?method=get_product_source')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function update_ps_pid_cnt() {
            return $http.get('/apis/products.cfc?method=update_ps_pid_cnt')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function update_active_ps_pid_cnt() {
            return $http.get('/apis/products.cfc?method=update_active_ps_pid_cnt')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_amazon_subjects() {
            return $http.get('/apis/products.cfc?method=get_amazon_subjects')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }


        function get_product_pod_dimensions() {
            return $http.get('/apis/products.cfc?method=get_product_pod_dimensions')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_content_themes(formData) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=get_content_themes_list',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function update_theme_pid_cnt() {
            return $http.get('/apis/products.cfc?method=update_theme_pid_cnt')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function update_active_ct_pid_cnt() {
            return $http.get('/apis/products.cfc?method=update_active_ct_pid_cnt')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_amz_overselling() {
            return $http.get('/apis/products.cfc?method=get_amz_overselling')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_spid_synd_sync_fail(filter) {
            return $http({
                method: 'POST',
                url: '/apis/store_products.cfc?method=get_spid_synd_sync_fail',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_spid_synd_sync_pending_pa_amz(filter) {
            return $http({
                method: 'POST',
                url: '/apis/store_products.cfc?method=get_spid_synd_sync_pending_pa_amz',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_spid_synd_sync_active_pa_amz(filter) {
            return $http({
                method: 'POST',
                url: '/apis/store_products.cfc?method=get_spid_synd_sync_active_pa_amz',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_spid_synd_sync_pending_pf_amz(filter) {
            return $http({
                method: 'POST',
                url: '/apis/store_products.cfc?method=get_spid_synd_sync_pending_pf_amz',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_spid_synd_sync_active_pf_amz(filter) {
            return $http({
                method: 'POST',
                url: '/apis/store_products.cfc?method=get_spid_synd_sync_active_pf_amz',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_inactive_being_sold() {
            return $http.get('/apis/products.cfc?method=get_inactive_being_sold')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_products_title_too_long() {
            return $http.get('/apis/products.cfc?method=get_products_title_too_long')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_parent_relationship_pending_count() {
            return $http.get('/apis/product_parent.cfc?method=get_parent_relationship_pending_count')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_ebay_overselling() {
            return $http.get('/apis/products.cfc?method=get_ebay_overselling')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_product_detail(pid) {
            return $http.get('/apis/products.cfc?method=get_products&product_id='+pid)
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function dup_upc_check(formData) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=dup_upc_check',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function editContentTheme(formData) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=editContentTheme',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function createContentTheme(formData) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=createContentTheme',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function adjustOrderItems(formData) {
            return $http({
                method: 'POST',
                url: '/apis/orders.cfc?method=adjustOrderItems',
                data: $.param(formData),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function editLeadTime(formData) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=editLeadTime',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function updLeadTime(formData) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=updLeadTime',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function allocate_upc(pid) {
            return $http.get('/apis/products.cfc?method=allocate_upc&product_id='+pid)
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function allocate_gco_upc(pid) {
            return $http.get('/apis/products.cfc?method=allocate_gco_upc&product_id='+pid)
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function create_product(formData) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=create_product',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function update_product(formData) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=update_product',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function tm_review(formData) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=tm_review',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function getProductAttributes(formData) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=getProductAttributes',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function getProductRelationships(formData) {
            return $http({
                method: 'POST',
                url: '/apis/product_relationships.cfc?method=getProductRelationships',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function getStoreProductRelationships(formData) {
            return $http({
                method: 'POST',
                url: '/apis/product_relationships.cfc?method=getStoreProductRelationships',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function getAllRelations(formData) {
            return $http({
                method: 'POST',
                url: '/apis/product_relationships.cfc?method=getAllRelations',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }


        function create_product_relationship(formData) {
            return $http({
                method: 'POST',
                url: '/apis/product_relationships.cfc?method=create_product_relationship',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function deleteProductRelationship(formData) {
            return $http({
                method: 'POST',
                url: '/apis/product_relationships.cfc?method=delete_product_relationship',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function getProductRelationshipTypes() {
            return $http.get('/apis/product_relationships.cfc?method=get_relationship_types')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_product_attributes(formData) {
            return $http({
                method: 'POST',
                url: '/apis/product_attributes.cfc?method=get_product_attributes',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function create_product_attribute(formData) {
            return $http({
                method: 'POST',
                url: '/apis/product_attributes.cfc?method=create_product_attribute',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function delete_product_attribute(formData) {
            return $http({
                method: 'POST',
                url: '/apis/product_attributes.cfc?method=delete_product_attribute',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function deleteProductParent(formData) {
            return $http({
                method: 'POST',
                url: '/apis/product_parent.cfc?method=deleteProductParent',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function createProductParent(formData) {
            return $http({
                method: 'POST',
                url: '/apis/product_parent.cfc?method=createProductParent',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function update_product_parent(formData) {
            return $http({
                method: 'POST',
                url: '/apis/product_parent.cfc?method=update_product_parent',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function resend_parent_relationship_childs(formData) {
            return $http({
                method: 'POST',
                url: '/apis/product_parent.cfc?method=resend_parent_relationship_childs',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }


	   function update_product_attributes(formData) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=updateProductAttributes',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function update_product_attributes_done_all_sizes(formData) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=update_product_attributes_done_all_sizes',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function update_product_name_all_sizes(formData) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=update_product_name_all_sizes',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function update_product_root(formData) {
           return $http({
               method: 'POST',
               url: '/apis/products.cfc?method=update_product_root',
               data: $.param(formData), // jquery pass in data as strings
               headers: {
                   'Content-Type': 'application/x-www-form-urlencoded'
               }
           }).error(function(data, status, headers, config) {
               // alert('error ! : ' + status);
           });
       }

       function update_product_source(formData) {
           return $http({
               method: 'POST',
               url: '/apis/products.cfc?method=update_product_source',
               data: $.param(formData), // jquery pass in data as strings
               headers: {
                   'Content-Type': 'application/x-www-form-urlencoded'
               }
           }).error(function(data, status, headers, config) {
               // alert('error ! : ' + status);
           });
       }

        function search_spids(formData) {
            return $http({
                method: 'POST',
                url: '/apis/store_products.cfc?method=search_spids',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function delete_set(formData) {
            return $http({
                method: 'POST',
                url: '/apis/store_products.cfc?method=delete_set',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function update_set(formData) {
            return $http({
                method: 'POST',
                url: '/apis/store_products.cfc?method=update_set',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function getProductSets(formData) {
            return $http({
                method: 'POST',
                url: '/apis/store_products.cfc?method=get_product_sets',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function add_sets(formData) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=add_sets',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function update_product_parent_audit(formData) {
            return $http({
                method: 'POST',
                url: '/apis/product_parent.cfc?method=update_product_parent_audit',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function update_product_parent_color_prefix(formData) {
            return $http({
                method: 'POST',
                url: '/apis/product_parent.cfc?method=update_product_parent_color_prefix',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function parent_override(formData) {
            return $http({
                method: 'POST',
                url: '/apis/product_parent.cfc?method=parent_override',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }


        function add_spid_product_parent(formData) {
            return $http({
                method: 'POST',
                url: '/apis/product_parent.cfc?method=add_spid_product_parent',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_product_parent(formData) {
            return $http({
                method: 'POST',
                url: '/apis/product_parent.cfc?method=get_product_parent',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_missing_title_parents() {
            return $http.get('/apis/product_parent.cfc?method=get_missing_title_parents')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_color_variation_issue_parents() {
            return $http.get('/apis/product_parent.cfc?method=get_color_variation_issue_parents')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_child_cnt_zero_parents() {
            return $http.get('/apis/product_parent.cfc?method=get_child_cnt_zero_parents')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_product_parent_v1(formData) {
            return $http({
                method: 'POST',
                url: '/apis/product_parent.cfc?method=get_product_parent_v1',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_store_products_for_parent(formData) {
            return $http({
                method: 'POST',
                url: '/apis/product_parent.cfc?method=get_store_products_for_parent',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_product_parent_status() {
            return $http.get('/apis/product_parent.cfc?method=get_product_parent_status')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_duplicate_asin_product_parents(formData) {
            return $http({
                method: 'POST',
                url: '/apis/product_parent.cfc?method=get_duplicate_asin_product_parents',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function update_product_rollup_count() {
            return $http.get('/apis/product_parent.cfc?method=update_product_rollup_count')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

         function update_ps_pid_cnt() {
            return $http.get('/apis/products.cfc?method=update_ps_pid_cnt')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_next_product_not_fit_to_sell() {
            return $http.get('/apis/products.cfc?method=get_next_product_not_fit_to_sell')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_price_rules() {
            return $http.get('/apis/store_products.cfc?method=get_price_rules')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_shipping_regions() {
            return $http.get('/apis/store_products.cfc?method=get_shipping_regions')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_faire_variants(store_product_id) {
            return $http.get('/apis/store_products.cfc?method=get_faire_variants&store_product_id=' + store_product_id)
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_reprice_reason() {
            return $http.get('/apis/repricer.cfc?method=get_reprice_reason')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_wal_reprice(inputData) {
            return $http({
                method: 'POST',
                url: '/apis/repricer.cfc?method=get_wal_reprice',
                data: $.param(inputData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_amz_buybox_status() {
            return $http.get('/apis/repricer.cfc?method=get_amz_buybox_status')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_min_max_rules() {
            return $http.get('/apis/store_products.cfc?method=get_min_max_rules')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_reprice_history(inputData) {
            return $http({
                method: 'POST',
                url: '/apis/repricer.cfc?method=get_reprice_history',
                data: $.param(inputData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_store_product_scrape_status() {
            return $http.get('/apis/store_products.cfc?method=get_store_product_scrape_status')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }
        function create_vendor(inputData) {
            return $http({
                method: 'POST',
                url: '/apis/vendors.cfc?method=create_vendor',
                data: $.param(inputData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function update_vendor(formData) {
            return $http({
                method: 'POST',
                url: '/apis/vendors.cfc?method=update_vendor',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function audit_vendor(formData) {
            return $http({
                method: 'POST',
                url: '/apis/vendors.cfc?method=audit_vendor',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_vendors(filter) {

            // use lodash to find if empty
            if ( _.isEmpty(filter) ) {
                filter = {};
            }

            return $http({
                method: 'POST',
                url: '/apis/vendors.cfc?method=get_vendors',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function get_vendors_v1(filter) {

            // use lodash to find if empty
            if ( _.isEmpty(filter) ) {
                filter = {};
            }

            return $http({
                method: 'POST',
                url: '/apis/vendors.cfc?method=get_vendors_v1',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function get_vendors_list(filter) {

            // use lodash to find if empty
            if ( _.isEmpty(filter) ) {
                filter = {};
            }

            return $http({
                method: 'POST',
                url: '/apis/vendors.cfc?method=get_vendors_list',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_manufacturer_report(filter) {

            // use lodash to find if empty
            if ( _.isEmpty(filter) ) {
                filter = {};
            }

            return $http({
                method: 'POST',
                url: '/apis/manufacturers.cfc?method=get_manufacturer_report',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_vendor_product_lines(inputData) {
            return $http({
                method: 'POST',
                url: '/apis/vendors.cfc?method=get_vendor_product_lines',
                data: $.param(inputData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function remove_parent(formData) {
            return $http({
                method: 'POST',
                url: '/apis/product_parent.cfc?method=deleteProductParent',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function get_vendor_auth_stores(inputData) {
            return $http({
                method: 'POST',
                url: '/apis/vendors.cfc?method=get_vendor_auth_stores',
                data: $.param(inputData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function delete_vendor_auth_stores(inputData) {
            return $http({
                method: 'POST',
                url: '/apis/vendors.cfc?method=delete_vendor_auth_stores',
                data: $.param(inputData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function create_vendor_auth_stores(inputData) {
            return $http({
                method: 'POST',
                url: '/apis/vendors.cfc?method=create_vendor_auth_stores',
                data: $.param(inputData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

         function get_audit_vendor(inputData) {
            return $http({
                method: 'POST',
                url: '/apis/vendors.cfc?method=get_audit_vendor',
                data: $.param(inputData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_vendor_detail(vid) {
            return $http.get('/apis/vendors.cfc?method=get_vendors&vid=' + vid)
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function create_vendor_product(formData) {
            return $http({
                method: 'POST',
                url: '/apis/vendor_products.cfc?method=create_vendor_product',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_product_categories() {
            return $http.get('/apis/product_categories.cfc?method=get_product_categories')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_product_orientation() {
            return $http.get('/apis/products.cfc?method=get_product_orientation')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_product_lead_time_group() {
            return $http.get('/apis/product_categories.cfc?method=get_product_lead_time_group')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }
        function get_product_lead_time_group_v1() {
            return $http.get('/apis/product_categories.cfc?method=get_product_lead_time_group_v1')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }
        function get_faster_lead_times() {
            return $http.get('/apis/product_categories.cfc?method=get_faster_lead_times')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_product_categories_v1(filter) {
            return $http({
                method: 'POST',
                url: '/apis/product_categories.cfc?method=get_product_categories',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_product_categories_list(filter) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=get_product_categories_list',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function get_product_categories_list_v1(filter) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=get_product_categories_list_v1',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_vendor_product_po_history(formData) {
            return $http({
                method: 'POST',
                url: '/apis/vendor_products.cfc?method=get_vendor_product_po_history',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_vendor_product_change_log(formData) {
            return $http({
                method: 'POST',
                url: '/apis/vendor_products.cfc?method=get_vendor_product_change_log',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_vendor_product_list(inputData) {
            return $http({
                method: 'POST',
                url: '/apis/vendor_products.cfc?method=get_vendor_product_list',
                data: $.param(inputData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_vendor_product_list_count(inputData) {
            return $http({
                method: 'POST',
                url: '/apis/vendor_products.cfc?method=get_vendor_product_list_count',
                data: $.param(inputData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_vendor_product(formData) {
            return $http({
                method: 'POST',
                url: '/apis/vendor_products.cfc?method=get_vendor_product',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_vendor_product_reorder(formData) {
            return $http({
                method: 'POST',
                url: '/apis/vendor_products.cfc?method=get_vendor_product_reorder',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_vendor_products_by_vendor(inputData) {
            return $http({
                method: 'POST',
                url: '/apis/vendor_products.cfc?method=get_vendor_products_by_vendor',
                data: $.param(inputData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_vendor_stock_status() {
            return $http.get('/apis/vendor_products.cfc?method=get_vendor_stock_status')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function update_vendor_product(formData) {
            return $http({
                method: 'POST',
                url: '/apis/vendor_products.cfc?method=update_vendor_product',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function unique_sku_check(vid,sku) {
            return $http.get('/apis/vendor_products.cfc?method=unique_sku_check&vendor_id='+vid+'&vendor_sku='+sku)
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_po_status() {
            return $http.get('/apis/purchase_orders.cfc?method=get_po_status')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_po_types() {
            return $http.get('/apis/purchase_orders.cfc?method=get_po_types')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_stores(filter) {

            // use lodash to find if empty
            if ( _.isEmpty(filter) ) {
                filter = {};
            }

            return $http({
                method: 'POST',
                url: '/apis/stores.cfc?method=get_stores',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function get_stores_v1(filter) {

            // use lodash to find if empty
            if ( _.isEmpty(filter) ) {
                filter = {};
            }

            return $http({
                method: 'POST',
                url: '/apis/stores.cfc?method=get_stores_v1',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_store_dashboard() {
            return $http.get('/apis/stores.cfc?method=get_store_dashboard')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_available_stores_via_product(pid) {
            return $http.get('/apis/stores.cfc?method=get_available_stores_via_product&product_id='+pid)
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_store_products(filter) {
            return $http({
                method: 'POST',
                url: '/apis/store_products.cfc?method=get_store_products',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_gcid_store_products(filter) {
            return $http({
                method: 'POST',
                url: '/apis/store_products.cfc?method=get_gcid_store_products',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_inv_to_push_store_products(filter) {
            return $http({
                method: 'POST',
                url: '/apis/store_products.cfc?method=get_inv_to_push_store_products',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_store_products_from_parent(filter) {
            return $http({
                method: 'POST',
                url: '/apis/store_products.cfc?method=get_store_products_from_parent',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function get_reprice_cnt(filter) {
            return $http({
                method: 'POST',
                url: '/apis/store_products.cfc?method=get_reprice_cnt',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_vendor_id(filter) {
            return $http({
                method: 'POST',
                url: '/apis/vendor_products.cfc?method=get_vendor_id',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }


        function get_store_products_sp_list(filter) {
            return $http({
                method: 'POST',
                url: '/apis/store_products.cfc?method=get_store_products_sp_list',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_store_products_p_list(filter) {
            return $http({
                method: 'POST',
                url: '/apis/store_products.cfc?method=get_store_products_p_list',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_store_product_detail(filter) {
            return $http({
                method: 'POST',
                url: '/apis/store_products.cfc?method=get_store_products',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_store_product_status() {
            return $http.get('/apis/store_products.cfc?method=get_store_product_status')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function create_store_product(formData) {
            return $http({
                method: 'POST',
                url: '/apis/store_products.cfc?method=create_store_product',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function update_store_product(formData) {
            return $http({
                method: 'POST',
                url: '/apis/store_products.cfc?method=update_store_product',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function calc_mp_avail_no_qtytosell_check(formData){
        	return $http({
                method: 'POST',
                url: '/tasks/products/calc_mp_avail_no_qtytosell_check.cfm',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function remove_store_product(formData) {
            return $http({
                method: 'POST',
                url: '/apis/store_products.cfc?method=remove_store_product',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_next_product_no_sku() {
            return $http.get('/apis/store_products.cfc?method=get_products_no_sku')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function create_location_product(formData) {
            return $http({
                method: 'POST',
                url: '/apis/location_product.cfc?method=create_location_product',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function get_location_name(location_type_id) {
            return $http.get('/apis/location_product.cfc?method=get_location_name&location_type_id='+location_type_id)
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }


        function update_location_product(formData) {
            return $http({
                method: 'POST',
                url: '/apis/location_product.cfc?method=update_location_product',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function delete_location(formData) {
            return $http({
                method: 'POST',
                url: '/apis/location_product.cfc?method=delete_location',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function delete_location_temp(location_id,loc_prod_id,product_id,location_number,warehouse_id) {
            return $http.get('/apis/location_product.cfc?method=delete_location&location_id='+location_id +'&loc_prod_id=' + loc_prod_id +'&product_id=' + product_id +'&location_number=' + location_number +'&warehouse_id=' + warehouse_id)
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_empty_locations() {
            return $http.get('/apis/locations.cfc?method=get_empty_locations')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }



        function audit_location_product(formData) {
            return $http({
                method: 'POST',
                url: '/apis/location_product.cfc?method=audit_location_product',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_location_products(formData) {
            return $http({
                method: 'POST',
                url: '/apis/location_product.cfc?method=get_location_products',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_empty_locations_details(formData) {
        	return $http({
                method: 'POST',
                url: '/apis/locations.cfc?method=get_empty_locations_details',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });

        }
        function get_best_seller(formData) {
        	return $http({
                method: 'POST',
                url: '/apis/location_product.cfc?method=get_best_seller',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });

        }

        function get_audit_history(formData) {
        	return $http({
                method: 'POST',
                url: '/apis/locations.cfc?method=get_audit_history',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });

        }


        function get_location_types(formData) {
            return $http({
                method: 'POST',
                url: '/apis/locations.cfc?method=get_location_types',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function get_on_hand(formData) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=get_on_hand',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_backstockRestock(formData) {
            return $http({
                method: 'POST',
                url: '/apis/location_product.cfc?method=get_backstockRestock',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_product_location(formData) {
            return $http({
                method: 'POST',
                url: '/apis/location_product.cfc?method=get_product_location',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_common_locations() {
            return $http.get('/apis/location_product.cfc?method=get_common_locations')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

      function get_backlights() {
        return $http.get('/apis/location_product.cfc?method=get_backlights')
            .error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
        });
      }
        function delete_location_product(formData) {
            return $http({
                method: 'POST',
                url: '/apis/location_product.cfc?method=delete_location_product',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }



        function get_open_location(location_type_id, product_id) {
            return $http.get('/apis/locations.cfc?method=get_open_location&location_type_id='+location_type_id +'&product_id=' + product_id)
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }
        function get_open_location_v1(location_type_id, product_id) {
            return $http.get('/apis/locations.cfc?method=get_open_location_v1&location_type_id='+location_type_id +'&product_id=' + product_id)
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }
        function get_location_history(location_type_id,location_number, product_id) {
            return $http.get('/apis/locations.cfc?method=get_location_history&location_type_id='+location_type_id +'&product_id=' + product_id +'&location_number=' + location_number)
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }


        function get_location_id(location_type_id, location_number) {
            return $http.get('/apis/locations.cfc?method=get_location_id&location_type_id='+location_type_id +'&location_number=' + location_number)
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_location_audit(formData) {
            return $http({
                method: 'POST',
                url: '/apis/location_product.cfc?method=get_location_audit',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function getAuditLog(formData) {
            return $http({
                method: 'POST',
                url: '/apis/audit.cfc?method=getAuditLog',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function getAuditSubTypes(formData) {
            return $http({
                method: 'POST',
                url: '/apis/audit.cfc?method=getAuditSubTypes',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function create_audit_log(formData) {
            return $http({
                method: 'POST',
                url: '/apis/audit.cfc?method=create_audit_log',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function create_purchase_order(formData) {
            return $http({
                method: 'POST',
                url: '/apis/purchase_orders.cfc?method=create_purchase_order',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function update_purchase_order(formData) {
            return $http({
                method: 'POST',
                url: '/apis/purchase_orders.cfc?method=update_purchase_order',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_purchase_orders(formData) {
            return $http({
                method: 'POST',
                url: '/apis/purchase_orders.cfc?method=get_purchase_orders',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_export_po_list(formData) {
            return $http({
                method: 'POST',
                url: '/apis/purchase_order_items.cfc?method=get_po_items_export',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_po_items(formData) {
            return $http({
                method: 'POST',
                url: '/apis/purchase_order_items.cfc?method=get_po_items',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_po_items_audit(formData) {
            return $http({
                method: 'POST',
                url: '/apis/purchase_order_items.cfc?method=get_po_items_audit',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_receiving(formData) {
            return $http({
                method: 'POST',
                url: '/apis/purchase_order_items.cfc?method=get_receiving',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function get_all_pods(formData) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=get_all_pods',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function get_pod_orders(formData) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=get_pod_orders',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function populate_picklist_pid(formData) {
            return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=populatePickpackSlipProduct',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }



        function get_message(formData) {
            return $http({
                method: 'POST',
                url: '/apis/message.cfc?method=get_message',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }


        function get_transfer_po_items(formData) {
            return $http({
                method: 'POST',
                url: '/apis/purchase_order_items.cfc?method=get_transfer_po_items',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function create_po_item(formData) {
            return $http({
                method: 'POST',
                url: '/apis/purchase_order_items.cfc?method=create_po_item',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function update_po_item(formData) {
            return $http({
                method: 'POST',
                url: '/apis/purchase_order_items.cfc?method=update_po_item',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function update_po_totals(formData) {
            return $http({
                method: 'POST',
                url: '/apis/purchase_orders.cfc?method=update_po_item',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_po_item_search(data) {
            return $http({
                method: 'POST',
                url: '/apis/purchase_order_items.cfc?method=get_po_item_search',
                data: $.param(data), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function getCustomerAddress(data) {
            return $http({
                method: 'POST',
                url: '/apis/customers.cfc?method=getCustomerAddress',
                data: $.param(data), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function update_customer_address(formData) {
            return $http({
                method: 'POST',
                url: '/apis/customers.cfc?method=update_customer_address',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function update_shipping_service(formData) {
            return $http({
                method: 'POST',
                url: '/apis/orders.cfc?method=update_shipping_service',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function getInvalidAddressReport() {
            return $http.get('/apis/customers.cfc?method=getInvalidAddressReport')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_country_province_list() {
            return $http.get('/apis/customers.cfc?method=get_country_province_list_flat')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_province_list() {
            return $http.get('/apis/customers.cfc?method=get_province_list')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_country_list() {
            return $http.get('/apis/customers.cfc?method=get_country_list')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function create_manufacturer(formData) {
            return $http({
                method: 'POST',
                url: '/apis/manufacturers.cfc?method=create_manufacturer',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function get_manufacturers_by_name(formData) {
            return $http({
                method: 'POST',
                url: '/apis/manufacturers.cfc?method=get_manufacturers',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function get_manufacturers() {
            return $http.get('/apis/manufacturers.cfc?method=get_manufacturers')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }
        function get_manufacturers_no_cache(formData) {
            return $http({
                method: 'POST',
                url: '/apis/manufacturers.cfc?method=get_manufacturers_no_cache',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function get_product_source_list_v1(formData) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=get_product_source_list',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function createProductSource(formData) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=create_ps',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

            function editProductSource(formData) {
                  return $http({
                        method: 'POST',
                        url: '/apis/products.cfc?method=editProductSource',
                        data: $.param(formData),
                        headers: {
                              'Content-Type': 'application/x-www-form-urlencoded'
                        }
                  }).error(function(data, status, headers, config) {
                  // alert('error ! : ' + status);
                  });
            }

        function get_product_source_list() {
            return $http.get('/apis/products.cfc?method=get_product_source_list')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_license_region_list() {
            return $http.get('/apis/products.cfc?method=get_license_region_list')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }
        function get_content_themes_list() {
            return $http.get('/apis/products.cfc?method=get_content_themes_list')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_scheduled_tasks(formData) {

            return $http({
                method: 'POST',
                url: '/apis/tasks.cfc?method=get_scheduled_tasks',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_amazon_errors() {
            return $http.get('/apis/tasks.cfc?method=get_amazon_errors')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function s3readFile(filelocation) {
            return $http.get('/apis/amazon.cfc?method=s3readFile&filelocation=' + filelocation)
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }
        function get_message_cnt(user_id) {
            return $http.get('/apis/message.cfc?method=get_message_cnt&user_id=' + user_id)
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_ship_methods() {
            return $http.get('/apis/shipping.cfc?method=get_ship_methods')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_ship_methods_v1(ship_method_id) {
            return $http.get('/apis/shipping.cfc?method=get_ship_methods_v1&ship_method_id=' + ship_method_id)
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_pp_shipping_methods() {
            return $http.get('/apis/shipping.cfc?method=get_pp_shipping_methods')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function update_pp_shipping_method(formData) {
            return $http({
                method: 'POST',
                url: '/apis/shipping.cfc?method=update_pp_shipping_method',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_picklists() {
            return $http.get('/apis/pickpack.cfc?method=get_picklists')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_picklist_type_id(formData) {
            return $http({
                method: 'POST',
                url: '/apis/packages.cfc?method=get_picklist_type_id',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_picklist_slip_id(formData) {
            return $http({
                method: 'POST',
                url: '/apis/packages.cfc?method=get_picklist_slip_id',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_reship_reasons() {
            return $http.get('/apis/shipping.cfc?method=get_reship_reasons')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function getOrderPackageFull(formData) {
            return $http({
                method: 'POST',
                url: '/apis/packages.cfc?method=getOrderPackageFull',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function getOrderProductSet(formData){
            return $http({
                method: 'POST',
                url: '/apis/packages.cfc?method=getOrderProductSet',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_order_packages(formData) {
            return $http({
                method: 'POST',
                url: '/apis/packages.cfc?method=get_order_packages',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_pending_wfp(formData) {
            return $http({
                method: 'POST',
                url: '/apis/packages.cfc?method=get_pending_wfp',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_order_package_items(formData) {
            return $http({
                method: 'POST',
                url: '/apis/packages.cfc?method=get_order_package_items',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function get_order_package_items_cnt(formData) {
            return $http({
                method: 'POST',
                url: '/apis/packages.cfc?method=get_order_package_items_cnt',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }



        function createOrderPackage(formData) {
            return $http({
                method: 'POST',
                url: '/apis/packages.cfc?method=createOrderPackage',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        
        function splitOrderPackage(formData) {
            return $http({
                method: 'POST',
                url: '/apis/packages.cfc?method=splitOrderPackage',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function update_package_pack_type_id(formData) {
            return $http({
                method: 'POST',
                url: '/apis/packages.cfc?method=update_package_pack_type_id',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function reset_order_package(formData) {
            return $http({
                method: 'POST',
                url: '/apis/packages.cfc?method=reset_order_package',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function cancel_open_order_packages(formData) {

            return $http({
                method: 'POST',
                url: '/apis/packages.cfc?method=cancel_open_order_packages',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function updateOrderPackage(formData) {

            return $http({
                method: 'POST',
                url: '/apis/packages.cfc?method=updateOrderPackage',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function updateFullPackageABS(formData) {

            return $http({
                method: 'POST',
                url: '/apis/packages.cfc?method=updateFullPackageABS',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function updatePackageABS(formData) {

            return $http({
                method: 'POST',
                url: '/apis/packages.cfc?method=updatePackageABS',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function updatePackageEndicia(formData) {
            return $http({
                method: 'POST',
                url: '/apis/packages.cfc?method=updatePackageEndicia',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function alertpackupdate(formData) {
            return $http({
                method: 'POST',
                url: '/apis/packages.cfc?method=alertpackupdate',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function createOrderPackageItem(formData) {
            return $http({
                method: 'POST',
                url: '/apis/packages.cfc?method=createOrderPackageItem',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function updateOrderPackageItem(formData) {
            return $http({
                method: 'POST',
                url: '/apis/packages.cfc?method=updateOrderPackageItem',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_order_package_status() {
            return $http.get('/apis/packages.cfc?method=get_order_package_status')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_order_package_types() {
            return $http.get('/apis/packages.cfc?method=get_order_package_types')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_order_package_aging() {
            return $http.get('/apis/packages.cfc?method=get_order_package_aging')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }
        function get_order_package_aging_v1() {
            return $http.get('/apis/packages.cfc?method=get_order_package_aging_v1')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }
        function manual_orders_no_tracking() {
            return $http.get('/apis/packages.cfc?method=manual_orders_no_tracking')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_order_package_ship_method() {
            return $http.get('/apis/packages.cfc?method=get_order_package_ship_method')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_order_shipments() {
            return $http.get('/apis/packages.cfc?method=get_order_shipments')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function updateOrderItem(formData) {
            return $http({
                method: 'POST',
                url: '/apis/orders.cfc?method=updateOrderItem',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_sales_velocity() {
            return $http.get('/apis/reporting.cfc?method=get_sales_velocity')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }
        function qPhantomReview() {
            return $http.get('/apis/reporting.cfc?method=qPhantomReview')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_sales_report(formData) {
            return $http({
                method: 'POST',
                url: '/apis/reporting.cfc?method=get_sales_report',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_walmart_reprice_report(formData) {
            return $http({
                method: 'POST',
                url: '/apis/reporting.cfc?method=get_walmart_reprice_report',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function get_amazon_reprice_report(formData) {
            return $http({
                method: 'POST',
                url: '/apis/reporting.cfc?method=get_amazon_reprice_report',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_asin_import_errors() {
            return $http.get('/apis/reporting.cfc?method=get_asin_import_errors')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_order_report() {
            return $http.get('/apis/reporting.cfc?method=get_order_report')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_order_fulfillment() {
            return $http.get('/apis/reporting.cfc?method=get_order_fulfillment')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function getPackageStatusCount(formData) {
            return $http({
                method: 'POST',
                url: '/apis/packages.cfc?method=getPackageStatusCount',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function get_order_packages_pod(formData) {
            return $http({
                method: 'POST',
                url: '/apis/packages.cfc?method=getOrdersPod',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }


        function stopTasks(formData) {
            return $http({
                method: 'POST',
                url: '/apis/tasks.cfc?method=stopTasks',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_product_sale_history(formData) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=get_product_sale_history',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function update_sales(formData) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=update_sales',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_orders_no_tracking(formData) {
            return $http({
                method: 'POST',
                url: '/apis/reporting.cfc?method=get_orders_no_tracking',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_orders_manual_shipmethod() {
            return $http.get('/apis/reporting.cfc?method=get_orders_manual_shipmethod')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_marketplace_upload_log(type_id, store_product_id) {
            return $http.get('/apis/audit.cfc?method=get_marketplace_upload_log&type_id=' + type_id + '&store_product_id=' + store_product_id)
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_warehouses() {
            return $http.get('/apis/warehouse.cfc?method=get_warehouses')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function create_marketplace_upload_log(formData) {
            return $http({
                method: 'POST',
                url: '/apis/audit.cfc?method=create_marketplace_upload_log',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_night_reprice(formData) {
            return $http({
                method: 'POST',
                url: '/apis/audit.cfc?method=get_night_reprice',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function endicia_order_export() {
            return $http.get('/apis/reporting.cfc?method=endicia_order_export')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }
	function export_customs_data() {
            return $http.get('/apis/reporting.cfc?method=export_customs_data')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function endicia_order_import(formData) {
            return $http({
                method: 'POST',
                url: '/apis/reporting.cfc?method=endicia_order_import',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function createBillOfLading(formData) {
            return $http({
                method: 'POST',
                url: '/apis/bill_of_lading.cfc?method=createBillOfLading',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }


        function getBillOfLading(formData) {
            return $http({
                method: 'POST',
                url: '/apis/bill_of_lading.cfc?method=getBillOfLading',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function competitor_product_list(formData) {
            return $http({
                method: 'POST',
                url: '/apis/competitors.cfc?method=competitor_product_list',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function phantom_products(formData) {
            return $http({
                method: 'POST',
                url: '/apis/competitors.cfc?method=phantom_products',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function update_phantom_products(formData) {
            return $http({
                method: 'POST',
                url: '/apis/competitors.cfc?method=update_phantom_products',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_competitor_summary(formData) {
            return $http({
                method: 'POST',
                url: '/apis/competitors.cfc?method=get_competitor_summary',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function getAlertLog(formData) {
            return $http({
                method: 'POST',
                url: '/apis/alert.cfc?method=get_alert_links',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function create_alert_link(formData) {
            return $http({
                method: 'POST',
                url: '/apis/alert.cfc?method=create_alert_link',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function update_alert_link(formData) {
            return $http({
                method: 'POST',
                url: '/apis/alert.cfc?method=update_alert_link',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function getAlertTypes(formData) {
            return $http({
                method: 'POST',
                url: '/apis/alert.cfc?method=getAlertTypes',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function getAlertSubTypes(formData) {
            return $http({
                method: 'POST',
                url: '/apis/alert.cfc?method=getAlertSubTypes',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function getAlertStatus(formData) {
            return $http({
                method: 'POST',
                url: '/apis/alert.cfc?method=getAlertStatus',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function get_aws_variation_themes() {
            return $http.get('/apis/amazon.cfc?method=get_aws_variation_themes')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_asin_list(formData) {
            return $http({
                method: 'POST',
                url: '/apis/store_products.cfc?method=get_asin_list',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_spid_title(formData) {
            return $http({
                method: 'POST',
                url: '/apis/store_products.cfc?method=get_spid_title',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_yoda_order_list(formData) {
        	return $http({
                method: 'POST',
                url: '/apis/orders.cfc?method=get_yoda_order_list',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function get_picklist_id(formData) {
        	return $http({
                method: 'POST',
                url: '/apis/pickpack.cfc?method=get_picklist_id',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function onsite_by_spid(formData) {
        	return $http({
                method: 'POST',
                url: '/apis/orders.cfc?method=onsite_by_spid',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_yoda_order_list_ebay(formData) {
        	return $http({
                method: 'POST',
                url: '/apis/orders.cfc?method=get_yoda_order_list_ebay',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function get_pid_list(formData) {
        	return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=get_pid_list',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_spid_list(formData) {
        	return $http({
                method: 'POST',
                url: '/apis/store_products.cfc?method=get_spid_list',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function get_fnsku_list(formData) {
        	return $http({
                method: 'POST',
                url: '/apis/store_products.cfc?method=get_fnsku_list',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_mpid_list(formData) {
        	return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=get_mpid_list',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function get_mparent_id_list(formData) {
        	return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=get_mparent_id_list',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function get_vsku_list(formData) {
        	return $http({
                method: 'POST',
                url: '/apis/vendor_products.cfc?method=get_vsku_list',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_upc_list(formData) {
        	return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=get_upc_list',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function update_ship_method(formData) {
        	return $http({
                method: 'POST',
                url: '/apis/shipping.cfc?method=update_ship_method',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }


        function print_image_missing_send_email(formData) {
            return $http({
                method: 'POST',
                url: '/apis/shipping.cfc?method=print_image_missing_send_email',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }


        function update_note(formData) {
        	return $http({
                method: 'POST',
                url: '/apis/shipping.cfc?method=update_note',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function walmart_push_product(formData) {
            return $http({
                method: 'POST',
                url: '/apis/walmart.cfc?method=unpublish_store_product',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function check_temp_search(filter) {
            return $http({
                method: 'POST',
                url: '/apis/store_products.cfc?method=check_temp_search',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function ins_save_search(filter) {
            return $http({
                method: 'POST',
                url: '/apis/store_products.cfc?method=ins_save_search',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function update_save_search(filter) {
            return $http({
                method: 'POST',
                url: '/apis/store_products.cfc?method=update_save_search',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_save_search(filter) {
            return $http({
                method: 'POST',
                url: '/apis/store_products.cfc?method=get_save_search',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

         function get_product_save_search(filter) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=get_product_save_search',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function check_temp_search_products(filter) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=check_temp_search_products',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function ins_save_search_products(filter) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=ins_save_search_products',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function update_save_search_products(filter) {
            return $http({
                method: 'POST',
                url: '/apis/products.cfc?method=update_save_search_products',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function push_jet_tracking_details(filter) {
            return $http({
                method: 'POST',
                url: '/apis/jet.cfc?method=push_jet_tracking_details',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_getty_images(filter) {
            return $http({
                method: 'POST',
                url: '/apis/getty.cfc?method=get_getty_images',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
            });
        }

        function get_stock_images(filter) {
            return $http({
                method: 'POST',
                url: '/apis/stock.cfc?method=get_stock_images',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function get_stock_images_dwd(filter) {
            return $http({
                method: 'POST',
                url: '/apis/stock.cfc?method=get_stock_images_dwd',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function get_stock_images_dwd_sold(filter) {
            return $http({
                method: 'POST',
                url: '/apis/stock.cfc?method=get_stock_images_dwd_sold',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_getty_image_products(filter) {
            return $http({
                method: 'POST',
                url: '/apis/getty.cfc?method=get_getty_image_products',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function download_getty_image(filter) {
            return $http({
                method: 'POST',
                url: '/apis/getty.cfc?method=download_getty_image',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function download_stock_image(filter) {
            return $http({
                method: 'POST',
                url: '/apis/stock.cfc?method=download_stock_image_comp',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function download_stock_image_hires(filter) {
            return $http({
                method: 'POST',
                url: '/apis/stock.cfc?method=download_stock_image_hires',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function download_only_getty_image(filter) {
            return $http({
                method: 'POST',
                url: '/apis/getty.cfc?method=download_only_getty_image',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_getty_id_list(filter) {
            return $http({
                method: 'POST',
                url: '/apis/getty.cfc?method=get_getty_id_list',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function get_getty_list(filter) {
            return $http.get('/apis/getty.cfc?method=get_getty_id_list')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function refund_order_item_jet(filter) {
            return $http({
                method: 'POST',
                url: '/apis/jet.cfc?method=refund_order_item',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function importAmazonMissedOrder(filter) {
            return $http({
                method: 'POST',
                //url: '/tasks/amazon/mws/pull/pull_missed_orders.cfm',
                url: '/tasks/sp_api/sp_api-pull-order-single.cfm',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function importAmazonMissedOnsiteOrder(filter) {
            return $http({
                method: 'POST',
                url: '/tasks/amazon/mws/pull/pull_missed_onsite_orders.cfm',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }
        function importWalmartMissedOrder(filter) {
            return $http({
                method: 'POST',
                url: '/tasks/walmart/pull_orders_single.cfm',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function createMissedOrder(filter) {
            return $http({
                method: 'POST',
                url: '/tasks/orders/create_manual_order.cfm',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function createmanualorder(formData){
            return $http({
                method: 'POST',
                url: '/tasks/orders/create_manual_order.cfm',
                data: $.param(formData), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }



        function parseAmazonMissedOrder(filter) {
            return $http({
                method: 'POST',
                url: '/tasks/amazon/mws/pull/orders/missed_order_parse.cfm',
                data: $.param(filter), // jquery pass in data as strings
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
            });
        }

        function image_format_update(url) {

            return $http({
                method: 'POST',
                url: url,
                //data: jsonData, // jquery pass in data as strings
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "X-Amz-Date":"",
                    "Authorization":"",
                    "x-api-key":""
                }
            }).error(function(data, status, headers, config) {
                // alert('error ! : ' + status);
                console.log(data);
                console.log(status);
                console.log(headers);
                console.log(config);
            });
        }

        function get_wayfair_subjects_list() {
            return $http.get('/apis/products.cfc?method=get_wayfair_subjects_list')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

        function get_amazon_subjects_list() {
            return $http.get('/apis/products.cfc?method=get_amazon_subjects_list')
                .error(function(data, status, headers, config) {
                    // alert('error ! : ' + status);
                });
        }

    }
})();
